import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["condensed", "fullHero"]

  connect() {
    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          this.condensedTarget.classList.remove("translate-y-0", "opacity-100", "pointer-events-auto")
          this.condensedTarget.classList.add("-translate-y-full", "opacity-0", "pointer-events-none")
        } else {
          this.condensedTarget.classList.remove("-translate-y-full", "opacity-0", "pointer-events-none")
          this.condensedTarget.classList.add("translate-y-0", "opacity-100", "pointer-events-auto")
        }
      },
      { rootMargin: "-60px 0px 0px 0px", threshold: 0 }
    )
    this.observer.observe(this.fullHeroTarget)
  }

  disconnect() {
    this.observer?.disconnect()
  }
}
